<template>
    <div>
        <table class="table table-hover table-bordered">
            <thead class="thead-dark">
                <slot name="columns" :headers="headers">
                    <th v-for="(header, i) in headers" :key="i">
                        {{header.name}}
                    </th>
                </slot>
            </thead>
            <tbody>
                <tr v-for="(row, i) in rows" :key="i">
                    <slot :row="row" :headers="headers">
                        <td v-for="(header, n) in headers" :key="n">
                            {{itemValue(row, header.field || '')}}
                        </td>
                    </slot>
                </tr>              
            </tbody>
        </table>
    </div>
</template>

<script>
    import Axios from 'axios';

    export default {
        props: [
            'data',
            'ruta',
            'headers'
        ],
        data () {
            return {
                page: 1,
                count: 0,
                rows: []
            }
        },
        methods:{
            getRows () {
                const vueThis = this
                Axios.get(this.ruta)
                .then( res => {
                    vueThis.rows = res.data || []
                })
                .catch(e => console.log(e))
            },
            itemValue (row, field) {
                if (row && row[field]){
                    return row[field]
                }
                return ''
            }
        },
        mounted() {
            if (this.data){
                this.rows = Array.isArray(this.data) ? this.data : []
            }else{
                this.getRows()
            }
        },
        watch:{
            data(val) {
                if (Array.isArray(val)){
                    this.rows = val
                } else {
                    this.rows = []
                }
            }
        }

    }
</script>
